import { render, staticRenderFns } from "./OutstandingOrderList.vue?vue&type=template&id=f47d2b58&scoped=true&"
import script from "./OutstandingOrderList.vue?vue&type=script&lang=js&"
export * from "./OutstandingOrderList.vue?vue&type=script&lang=js&"
import style0 from "./OutstandingOrderList.vue?vue&type=style&index=0&id=f47d2b58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47d2b58",
  null
  
)

export default component.exports